import { Box, Typography } from "@mui/material";

export const MessageImage = ({ message, isOwn, onOpenImagePreview }) => {
  const imageUrl = message.content?.file || message.content?.url || message.content?.image || "https://via.placeholder.com/200";

  const imageName = message.content?.name || message.content?.filename || "imagen_sin_nombre.png";

  const handleOpenPreview = () => {
    if (onOpenImagePreview) {
      onOpenImagePreview(imageUrl, imageName);
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: isOwn ? "flex-end" : "flex-start",
        gap: 0.75,
      }}
    >
      <Box
        component="img"
        src={imageUrl}
        alt={imageName}
        sx={{
          width: "100%",
          maxWidth: 260,
          maxHeight: 180,
          objectFit: "cover",
          borderRadius: 3,
          cursor: "pointer",
          transition: "transform 0.2s ease, box-shadow 0.2s ease",
          border: "1px solid rgba(var(--fx-surface-textrgb, 15, 23, 42), 0.12)",
          boxShadow: "0 2px 8px rgba(0,0,0,0.12)",
          "&:hover": {
            transform: "scale(1.02)",
            boxShadow: "0 4px 12px rgba(0,0,0,0.2)",
          },
        }}
        onClick={handleOpenPreview}
      />

      <Typography
        variant="caption"
        sx={{
          fontSize: "0.75rem",
          color: "inherit",
          textAlign: isOwn ? "right" : "left",
          maxWidth: 260,
          wordBreak: "break-all",
          px: 0.5,
          opacity: 0.7,
        }}
      >
        {imageName}
      </Typography>
    </Box>
  );
};
